import { browserHistory } from "react-router";
import closeAndArchiveClass from 'process/class/closeAndArchiveClass';
import { alert } from 'util/alert';
import { userCan } from 'containers/__R';
export const SETTING_WIDTH = "14%";

export default function(classState) {

  if (classState == 'archived') {
    return getArchivedClassTableSettings.call(this);
  }

  return getDefaultTableSettings.call(this);
}

// 'this' refers to DefaultTab
function getDefaultTableSettings() {
  const TabComponent = this;
  // 'this props' refers to DefaultTab.props
  const { pagination } = this.props.classList;
  return [
    {
      title: __('Add Lesson', 'class'),
      onClick: ({trData: classDetail}) => {
        browserHistory.push({
          pathname: `/class-detail/${classDetail.classID}`,
          state: {
            openCreateLessonDock: true,
          },
        });
      },
      isDisabled: () => {
        return !userCan('create_lesson')
      }
    },
    {
      title: __("Attendance", "class"),
      onClick: ({trData: classInfo}) => {
        browserHistory.push(`/class-detail/${classInfo.classID}`);
      },
      isDisabled: ({trData: classInfo}) => {
        return (classInfo.has_lesson == false || !userCan('manually_check_in'))
      }
    },
    {
      title: __("Close", "class"),
      onClick: ({trData: classInfo}) => {
        closeAndArchiveClass(classInfo, 'group')
        .then(()=>{
          TabComponent.fetchClassList(pagination.activePage);
        })
        .catch((err)=>{
          alert.error(err);
        });
      },
      isDisabled: () => {
        return !userCan('close_class')
      }
    },
  ]

}

// Specifically used for archived student table
function getArchivedClassTableSettings() {
  let TabComponent = this;
  let {dispatch} = this.props

	return [
	]

}



// WEBPACK FOOTER //
// ./src/containers/pages/Class/table-settings.js